import React, { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import translations from "../lang";
import "./privacy.css";

function useLanguage() {
  return localStorage.getItem("language") || "ro";
}

export default function PrivacyPolicy() {
  const lang = useLanguage();
  const t = translations[lang] || translations.ro;

  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    document.title = `${t.privacy_policy || "Privacy Policy"} – MyServiceHub`;
  }, [t]);

  const backLabel = t.back_to_register || "←";

  // ✅ ha Login-ről jöttünk, oda megy vissza, különben /register
  const backTarget = location.state?.from || "/register";

  return (
    <main className="privacy-wrap">
      <div className="privacy-actions">
        <button
          type="button"
          className="btn-back"
          onClick={() => navigate(backTarget)}
          aria-label={backLabel}
        >
          {backLabel}
        </button>
      </div>

      <h1>{t.privacy_modal_title || t.privacy_policy}</h1>

      <section>
        <h2>{t.privacy_modal_1_title}</h2>
        <p>{t.privacy_modal_1_content}</p>
      </section>

      <section>
        <h2>{t.privacy_modal_2_title}</h2>
        <p>{t.privacy_modal_2_content}</p>
      </section>

      <section>
        <h2>{t.privacy_modal_3_title}</h2>
        <p>{t.privacy_modal_3_content}</p>
      </section>

      <section>
        <h2>{t.privacy_modal_4_title}</h2>
        <p>{t.privacy_modal_4_content}</p>
      </section>

      <section>
        <h2>{t.privacy_modal_5_title}</h2>
        <p>{t.privacy_modal_5_content}</p>
      </section>

      <section>
        <h2>{t.privacy_modal_6_title}</h2>
        <p>{t.privacy_modal_6_content}</p>
      </section>

      <section>
        <h2>{t.privacy_modal_7_title}</h2>
        <ul>
          <li>{t.privacy_modal_7_list1}</li>
          <li>{t.privacy_modal_7_list2}</li>
          <li>{t.privacy_modal_7_list3}</li>
        </ul>
      </section>

      <section>
        <h2>{t.privacy_modal_8_title}</h2>
        <p>{t.privacy_modal_8_content}</p>
      </section>
    </main>
  );
}
